export default __webpack_public_path__ + "static/media/142.bef2c8b0.png";